export default __webpack_public_path__ + "static/media/pika.a937902d.gif";